import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { GlobalFilterButton } from 'components/common/GlobalFilterButton/GlobalFilterButton';
import { GlobalFilterComponent } from 'components/common/GlobalFilterComponent/GlobalFilterComponent';
import { ProgramTagsFilter } from 'components/common/GlobalFilterComponent/components/ProgramTagsFilter/programTagsFilter';
import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { PageWidgetWrapper } from 'components/common/PageWidgetWrapper/PageWidgetWrapper';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import { portfolioConfig } from 'components/Dashboards/Portfolio/portfolioConfig';
import { OverallStatus } from 'components/widgets/OverallStatus/OverallStatus';
import { ProjectScorecards } from 'components/widgets/ProjectScorecards/ProjectScorecards';
import { TimelineAndDensity } from 'components/widgets/timelineAndDensity/timelineAndDensity';

export const PortfolioOverviewPage = () => {
    useFullStoryPageView({ pageName: portfolioConfig.portfolioOverview.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <GlobalFilterButton />
                </VersionWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={portfolioConfig.portfolioOverview.title} />
                    <GlobalFilterComponent defaultValues={{ programTags: [] }}>
                        <ProgramTagsFilter name={'programTags'} />
                    </GlobalFilterComponent>
                </BottomHeaderSection>
            </HeaderWrapper>

            <MainContent>
                <PageWidgetWrapper>
                    <OverallStatus />
                    <ProjectScorecards />
                    <TimelineAndDensity />
                </PageWidgetWrapper>
            </MainContent>
        </PageContainer>
    );
};
